export default __webpack_public_path__ + "static/media/car2.acbdb922.png";